module.exports = __webpack_public_path__ + "static/studentsports_area-code-baseball-4074ebefd091744d4477b0b9784eea19.jpg";